module.exports = __webpack_public_path__ + "static/media/LandingPage-Surveys.9ad4dba8.png";